// extracted by mini-css-extract-plugin
export default {"typingIndicator":"TypingIndicator_typingIndicator__k-toS","dot":"TypingIndicator_dot__ymzJz","blink":"TypingIndicator_blink__a22Gb"};